// Common
import { FEATURE_NAME, namespace } from './gallery';
import compose from '../../../../lib/compose';
import connect from '../../../../store/connect';
import connectOctopus from '../../../../store/connect-octopus';
import withFeatureFlag from '../../../../components/feature-flag/with-feature-flag';
import experimentSelector from '../../../../components/experiment-selector';
// Component
import GalleryWrapper from '../../../../components/gallery';
import jsonToPropsComponent from '../../../../components/gallery/json-to-props';

// ComponentWithExperiment
import { withPlugins } from '../../../../utils/octopus';
import {
  GalleryDesktop,
  PluginClipsDesktop as clipsPlugin,
} from '../../../../components/gallery-with-plugins/gallery.desktop';
import jsonToPropsWithExperiment from '../../../../components/gallery-with-plugins/helpers/json-to-props';

const mapStateToProps = jsonToProps => ({ components: { [FEATURE_NAME]: gallery, header } }) => ({
  ...jsonToProps({ ...gallery, titleForAlt: header?.title }),
  app: 'pdp',
  title: header?.title,
  namespace,
});

const enhance = compose(
  withFeatureFlag(FEATURE_NAME),
  connect(mapStateToProps(jsonToPropsComponent)),
);

const enhanceWithExperiment = compose(
  withFeatureFlag(FEATURE_NAME),
  connectOctopus(mapStateToProps(jsonToPropsWithExperiment)),
  withPlugins(clipsPlugin),
);

const Component = enhance(GalleryWrapper);
const ComponentWithExperiment = enhanceWithExperiment(GalleryDesktop);

export default experimentSelector({
  experimentName: 'octopus-gallery-plugin',
  Component,
  ComponentWithExperiment,
});
